import Icon from '../components/Icon.vue'

Icon.register({
  couch: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M160 224c0-35.3-28.7-64-64-64h-32c0-53 43-96 96-96h320c53 0 96 43 96 96h-32c-35.3 0-64 28.7-64 64v64h-320v-64zM576 192c35.3 0 64 28.7 64 64 0 23.6-13 44-32 55.1v120.9c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-16h-384v16c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-120.9c-19-11.1-32-31.5-32-55.1 0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32v96h384v-96c0-17.7 14.3-32 32-32h32z'
      }
    ]
  }
})
